const REGISTER_USER = 'REGISTER_USER';
const SET_REGISTER_FORM_DATA = 'SET_REGISTER_FORM_DATA';
const SELECT_PACKAGE_TO_BUY = 'SELECT_PACKAGE_TO_BUY';
const REGISTER_USER_FREE_PLAN = 'REGISTER_USER_FREE_PLAN';
const SET_NEW_PASSWORD = 'SET_NEW_PASSWORD';
const REQUEST_VALIDATE_PASSWORD_TOKEN  = 'REQUEST_VALIDATE_PASSWORD_TOKEN';

const registerUser = data => {
    return {
        type: REGISTER_USER,
        data
    };
}

const sendRegisterFormData = data => {
    return {
        type: SET_REGISTER_FORM_DATA,
        data
    }
}

const selectPackageToBuy = data => {
    return {
        type: SELECT_PACKAGE_TO_BUY,
        data
    }
}

const registerUserFreePlan = data => {
    return {
        type: REGISTER_USER_FREE_PLAN,
        data
    }
}

const setNewPassword = data => {
    return {
        type: SET_NEW_PASSWORD,
        data
    }
}

const requestValidatePasswordToken = data => {
    return {
        type: REQUEST_VALIDATE_PASSWORD_TOKEN,
        data
    };
}


export default {
    types: {
        REGISTER_USER,
        SET_REGISTER_FORM_DATA,
        SELECT_PACKAGE_TO_BUY,
        REGISTER_USER_FREE_PLAN,
        SET_NEW_PASSWORD,
        REQUEST_VALIDATE_PASSWORD_TOKEN
        
    },
    actions: {
        registerUser,
        sendRegisterFormData,
        selectPackageToBuy,
        registerUserFreePlan,
        setNewPassword,
        requestValidatePasswordToken
    }
}